/**
 * @author        tae@zumper.com (Tae Yoon)
 * @copyright     Copyright (c) 2019, Zumper
 * @description   MessagingModal Constants
 */

export const START_FETCHING_ENTITY = '@@nzr/modals/MessagingModal/START_FETCHING_ENTITY'
export const CANCEL_FETCHING_ENTITY = '@@nzr/modals/MessagingModal/CANCEL_FETCHING_ENTITY'
export const RECEIVE_ENTITY = '@@nzr/modals/MessagingModal/RECEIVE_ENTITY'
export const ERROR_FETCHING_ENTITY = '@@nzr/modals/MessagingModal/ERROR_FETCHING_ENTITY'
export const DONE_FETCHING_ENTITY = '@@nzr/modals/MessagingModal/DONE_FETCHING_ENTITY'

export const RECEIVE_DATA = '@@nzr/modals/MessagingModal/RECEIVE_DATA'

export const NEXT_STEP = '@@nzr/modals/MessagingModal/NEXT_STEP'
export const PREVIOUS_STEP = '@@nzr/modals/MessagingModal/PREVIOUS_STEP'
